<template>
	<div class="table-options" :class="$vuetify.breakpoint.smAndDown ? 'd-none': ''">
		Viewing:
		<v-select
			class="mx-5"
			v-model="select_approval_status"
			:items="statuses"
			:menu-props="{ bottom: true, offsetY: true}"
			append-icon="mdi-chevron-down"
			:label="select_approval_status.length === 0 ? '':'All Claims'"
			color="rgba(25, 42, 62, 0.7)"
			item-color="white"
			solo
			dense
			hide-details
			multiple
			return-object
			@change="onStatusChange()"
		>
			<template v-slot:selection="{ item, index }">
				<span v-if="select_approval_status.length === statuses.length && index === 0" style="padding-top: 2px" >All Claims</span>
				<span v-if="select_approval_status.length === 1 && index === 0" style="padding-top: 2px" >{{ item.text }}</span>
				<span v-if="select_approval_status.length !== statuses.length && select_approval_status.length > 1 && index === 0"  style="padding-top: 2px" >{{ select_approval_status.length }} statuses...</span>
			</template>
			<template v-slot:item="{item, on, attrs}">
				<v-list-item v-on="on">
					<v-simple-checkbox
						:value="attrs.inputValue"
						:ripple="false"
						v-on="on"
						color="info"
						dense
					></v-simple-checkbox>
					<span class="checkbox-text ml-4"> {{ item.text }}</span>
				</v-list-item>
			</template>
		</v-select>
		<v-select
			v-model="select_customise_view"
			:items="customise_view"
			label="Customise View"
			append-icon="mdi-chevron-down"
			:menu-props="{ bottom: true, offsetY: true}"
			color="rgba(25, 42, 62, 0.7)"
			item-color="white"
			solo
			dense
			hide-details
			multiple
			return-object
			@change="onCustomiseChange()"
		>
			<template v-slot:selection="{ index }">
				<span style="padding-top: 2px" v-if="index === 0">Customise View</span>
				<span v-if="index === 1"></span>
			</template>
			<template v-slot:item="{item, on, attrs}">
				<v-list-item v-on="on">
					<v-simple-checkbox
						:value="attrs.inputValue"
						:ripple="false"
						v-on="on"
						color="info"
						dense
					></v-simple-checkbox>
					<span class="checkbox-text ml-4"> {{ item.text }}</span>
				</v-list-item>
			</template>
		</v-select>
	</div>
</template>
<script>

export default {
	name: 'ClaimView',
	props: {
		typeSelected: {
			type: Array,
			default: () => []
		},
		viewSelected: {
			type: Array,
			default: () => []
		},
		statuses: {
			type: Array,
			default: () => []
		},
		customise_view: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			select_approval_status: this.typeSelected,
			select_customise_view: this.viewSelected.map(item => { return item.value }),
		}
	},
	watch: {
		typeSelected() {
			this.select_approval_status = this.typeSelected;
		},
		viewSelected() {
			this.select_customise_view = this.viewSelected;
		},
	},
	methods: {
		onStatusChange() {
			this.$emit('status', this.select_approval_status);
		},
		onCustomiseChange() {
			const arr_tmp = [];
			this.select_customise_view.forEach(column => {
				const item = typeof(column) === 'object' ? column.value : column;
				arr_tmp.push(item);
			})

			this.$emit('column', arr_tmp);
		}
	}
}
</script>
<style lang="scss" scoped>
.table-options {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  div {
    width: 200px;
  }
}
.checkbox-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 18px;
  color: #192A3E;
}
.v-list--dense .v-list-item {
  min-height: 32px;
}
</style>